export default {
  // any array should have unique values as the values are used as keys
  // months
  formattedShortMonths: [
    'Jan',
    'Feb',
    'Mrt',
    'Apr',
    'Mei',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dec',
  ],
  months: [
    'Januari',
    'Februari',
    'Maart',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Augustus',
    'September',
    'Oktober',
    'November',
    'December',
  ],
  months_calendar: {
    January: 'Januari',
    February: 'Februari',
    March: 'Maart',
    April: 'April',
    May: 'Mei',
    June: 'Juni',
    July: 'Juli',
    August: 'Augustus',
    September: 'September',
    October: 'Oktober',
    November: 'November',
    December: 'December',
  },
  // weekdays
  weekdays: ['Zo', 'M', 'Di', 'W', 'Do', 'V', 'Za'],
  weekdays_booking_container: {
    Sunday: 'Zondag',
    Monday: 'Maandag',
    Tuesday: 'Dinsdag',
    Wednesday: 'Woensdag',
    Thursday: 'Donderdag',
    Friday: 'Vrijdag',
    Saturday: 'Zaterdag',
  },
  weekdays_calendar: {
    Sun: 'Zo',
    Mon: 'Ma',
    Tue: 'Di',
    Wed: 'Wo',
    Thu: 'Do',
    Fri: 'Vr',
    Sat: 'Za',
  },
  // additional translations
  today: 'Vandaag',
  tomorrow: 'Morgen',
};
